export const TENANT_TABS = [
  'organisation',
  'users',
  'labels-and-groups',
] as const;

export type TenantTabId = (typeof TENANT_TABS)[number];

export const DEFAULT_TENANT_TAB: TenantTabId = 'organisation';

export function isTenantTabId(value: string | undefined): value is TenantTabId {
  return (
    value !== undefined && (TENANT_TABS as readonly string[]).includes(value)
  );
}

export function resolveTenantTabPath(
  tabId: TenantTabId = DEFAULT_TENANT_TAB,
): string {
  return `/organisation-management/${tabId}`;
}

export function resolveTenantUserPath(userId: string): string {
  return `/organisation-management/users/${encodeURIComponent(userId)}`;
}
